import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Printer } from "lucide-react";
import { fmtDate, fmtDT, num } from "@/lib/format";
import { useFetch } from "@/hooks/useFetch";

export default function IssueSlip({ issue, onClose }) {
  const { data: prof } = useFetch(issue ? "/settings/business-profile" : null);
  return (
    <Dialog open={!!issue} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="issue-slip-dialog">
        <DialogHeader><DialogTitle>Stock Issue Slip</DialogTitle></DialogHeader>
        {issue && (
          <div className="print-area space-y-3 text-sm">
            {prof?.name && <div className="border-b pb-1 text-center"><p className="text-base font-bold" data-testid="slip-business-name">{prof.name}</p>{(prof.address || prof.phone) && <p className="text-[11px] text-slate-500">{prof.address} {prof.phone && `· ${prof.phone}`}</p>}</div>}
            <div className="flex justify-between border-b border-dashed pb-2">
              <div><p className="text-xs uppercase text-slate-500">Issue ID</p><p className="font-mono font-bold" data-testid="slip-issue-no">{issue.issue_no}</p></div>
              <div className="text-right"><p className="text-xs uppercase text-slate-500">Date</p><p className="font-semibold">{fmtDate(issue.date)}</p></div>
            </div>
            <p><span className="text-slate-500">Salesman:</span> <span className="font-semibold">{issue.salesman_name} ({issue.salesman_code})</span></p>
            <table className="w-full">
              <thead><tr className="border-b text-left text-xs uppercase text-slate-500"><th className="py-1">Product</th><th className="py-1 text-right">Packs</th></tr></thead>
              <tbody>
                {issue.items.map((i) => (
                  <tr key={i.product_id} className="border-b border-slate-100"><td className="py-1.5">{i.name} <span className="text-xs text-slate-400">{i.sku}</span></td><td className="py-1.5 text-right font-mono">{num(i.qty)}</td></tr>
                ))}
              </tbody>
              <tfoot><tr className="font-bold"><td className="py-2">Total Packs</td><td className="py-2 text-right font-mono" data-testid="slip-total-packs">{num(issue.total_packs)}</td></tr></tfoot>
            </table>
            {issue.remarks && <p className="text-slate-600">Remarks: {issue.remarks}</p>}
            <p className="text-xs text-slate-500">Issued by {issue.issued_by_name || issue.issued_by} · {fmtDT(issue.created_at)}</p>
          </div>
        )}
        <Button variant="outline" className="no-print" onClick={() => window.print()} data-testid="slip-print-button"><Printer className="mr-2 h-4 w-4" /> Print</Button>
      </DialogContent>
    </Dialog>
  );
}
